import React, { createContext, useContext, useEffect, useState } from "react";

const ThemeContext = createContext(null);

export function ThemeProvider({ children }) {
  const stored = typeof window !== "undefined" ? localStorage.getItem("veloura_theme") : null;
  const [theme, setThemeState] = useState(stored || "dark");
  const [chooser, setChooser] = useState(!stored);

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
  }, [theme]);

  const setTheme = (t) => {
    setThemeState(t);
    localStorage.setItem("veloura_theme", t);
    setChooser(false);
  };
  const toggle = () => setTheme(theme === "dark" ? "light" : "dark");
  const dismissChooser = () => { localStorage.setItem("veloura_theme", theme); setChooser(false); };

  return (
    <ThemeContext.Provider value={{ theme, setTheme, toggle, chooser, dismissChooser }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const c = useContext(ThemeContext);
  if (!c) throw new Error("useTheme must be used within ThemeProvider");
  return c;
}
